import { TitleCasePipe } from "@angular/common";
import { Component, Input, OnInit, ViewChild } from "@angular/core";
import { Modal } from "ngx-modal";
import { OperatingCountryEnums } from "../../enums/countries.enums";
import { CustomerService } from "../../services/customer.service";
import { TranslateService } from "@ngx-translate/core";
import { CommonService } from "../../../shared/services/common.service";
import { NotificationType } from "../../enums/notification-types.enum";

@Component({
    selector: "app-email-signature",
    templateUrl: "../../templates/template1/views/department/email-signature.component.html",
    styleUrls: ["../../templates/template1/themes/default/css/email-signature.less"],
    providers: [TitleCasePipe]
})
export class EmailSignatureComponent implements OnInit {
    @Input() operatingCountryId: number;
    operatingCountryCode = '';
    operatingCountries = [];
    editorData = '';
    editIndex = null;
    isRequired = false;
    globalEmailSignatureList = [];
    emailSignatureList = [];
    isLoading = false;
    @ViewChild('addSignature') addSignatureModal: Modal;

    constructor(private _customerservice: CustomerService,
        private _titlecasePipe: TitleCasePipe,
        private _translatePipe: TranslateService,
        private _commonService: CommonService,
    ) {
    }

    ngOnInit() {
        this.getOperatingCountries();
    }

    /**
     * To Get the operating countries
     */
    getOperatingCountries(): void {
        this._customerservice.getAllBusinessEntities().subscribe((response: any) => {
            if (response) {
                this.operatingCountries = response;
                let countryInfo = this.operatingCountries.find((country: any) => country.id === OperatingCountryEnums.USA);
                if (countryInfo) {
                    this.operatingCountries.splice(this.operatingCountries.indexOf(countryInfo), 1);
                    this.operatingCountries.splice(0, 0, countryInfo);
                    this.getOperatingCountryCode();
                }
            } else {
                this.operatingCountries = [];
            }
        }, error => {
            this.operatingCountries = [];
            const message: any = this._translatePipe.get('department-system.Something Went Wrong, Please try again after some time');
            this._commonService.createNotification('', message.value, NotificationType.ERROR);
        });
    }

    /**
     * Get Operating country code from the operating countries list.
     */
    getOperatingCountryCode(): void {
        const operatingCountry = this.operatingCountries.find(x => x.id === this.operatingCountryId);
        if (operatingCountry) {
            this.operatingCountryCode = operatingCountry.value ? operatingCountry.value : '';
            this.getEmailSignatures();
        }
    }

    /**
     * To Get the Email signatures list from S3
     */
    getEmailSignatures(): void {
        this._customerservice.getEmailSignatures().subscribe(response => {
            if (response && response.length > 0) {
                this.globalEmailSignatureList = JSON.parse(JSON.stringify(response));
                this.filterEmailSignatureByCountryCode();
            }
            else {
                this.globalEmailSignatureList = [];
                this.emailSignatureList = [];
            }
        }, (error) => {
            this.globalEmailSignatureList = [];
            this.emailSignatureList = [];
            const message: any = this._translatePipe.get('department-system.Something Went Wrong, Please try again after some time');
            this._commonService.createNotification('', message.value, NotificationType.ERROR);
        });
    }

    /**
     * Filter email signature by country code.
     */
    filterEmailSignatureByCountryCode(): void {
        const emailList = this.globalEmailSignatureList.filter(x => x.isoCodeThree.toLowerCase() === this.operatingCountryCode.toLowerCase())
        this.emailSignatureList = JSON.parse(JSON.stringify(emailList));
    }

    /**
     * Set the editor data when click on edit
     */
    editSignature(data, index): void {
        setTimeout(() => {
            this.onChangeContentEditor('content-editable-update');
        }, 100);
        this.editorData = data;
        this.editIndex = index;
    }

    /**
     * To close the editor
     */
    closeEditor(): void {
        this.editIndex = null;
    }


    /**
     * Update the signature
     */
    updateSignature(isoCodeThree): void {
        const editor: any = document.querySelector('#content-editable-update');
        const signature = editor ? editor.innerHTML : '';
        const index = this.globalEmailSignatureList.findIndex(x => x.isoCodeThree.toLowerCase() === isoCodeThree.toLowerCase());
        if (index > -1 && this.validateSignature(signature, editor)) {
            const updateSignature = this.addEmailIdAttribute(signature);
            let updateSignatureList = JSON.parse(JSON.stringify(this.globalEmailSignatureList));
            updateSignatureList[index].signature = updateSignature;
            this.postSignatureDetails(updateSignatureList, false);
        }
    }

    /**
     * To open the modal popup for add signature
     */
    onAddSignatureOpen(): void {
        this.editIndex = null;
        this.editorData = '';
        this.isRequired = false;
        this.addSignatureModal.open();
        setTimeout(() => {
            this.onChangeContentEditor('content-editable-add');
        }, 100);
    }

    /**
     * To close the modal popup for add signature
     */
    onAddSignatureClose(): void {
        this.editIndex = null;
        this.editorData = '';
        this.isRequired = false;
        const addPopupElement = document.querySelector('#content-editable-add');
        if (addPopupElement) {
            addPopupElement.innerHTML = '';
        }
        this.addSignatureModal.close();
    }

    /**
     * To Save the signtaure details
     */
    onSaveAddSignature(): void {
        const editor: any = document.querySelector('#content-editable-add');
        const signature = editor ? editor.innerHTML : '';
        const index = this.operatingCountries.findIndex(x => x.id === this.operatingCountryId);
        if (index > -1 && this.validateSignature(signature, editor)) {
            const updateSignature = this.addEmailIdAttribute(signature);
            const country = this.operatingCountries[index];
            const newSignature = {
                isoCodeThree: country.value,
                countryName: this._titlecasePipe.transform(country.name),
                signature: updateSignature
            }
            let updateSignatureList = JSON.parse(JSON.stringify(this.globalEmailSignatureList));
            updateSignatureList.push(newSignature);
            this.postSignatureDetails(updateSignatureList, true);
        }
    }

    /**
     * To Save the signature details to AWSS3
     */
    postSignatureDetails(updateSignatureList, isAdd): void {
        let message: any = '';
        this.isLoading = true;
        const request = {
            key: "portals/customercare/template1/json",
            content: JSON.stringify(updateSignatureList),
            extension: "json",
            fileName: "email-signature"
        }
        this._customerservice.uploadToAWS(request).subscribe(response => {
            this.isLoading = false;
            if (response) {
                if (isAdd) {
                    message = this._translatePipe.get('department-system.Signature Added Successfully');
                    this._commonService.createNotification('', message.value, NotificationType.SUCCESS);
                    this.onAddSignatureClose();
                } else {
                    message = this._translatePipe.get('department-system.Signature Updated Successfully');
                    this._commonService.createNotification('', message.value, NotificationType.SUCCESS);
                }
                this.globalEmailSignatureList = JSON.parse(JSON.stringify(updateSignatureList));
                this.filterEmailSignatureByCountryCode();
                this.isRequired = false;
                this.editIndex = null;
                this.editorData = '';
            }
        }, error => {
            this.isLoading = false;
            message = this._translatePipe.get('department-system.Something Went Wrong, Please try again after some time');
            this._commonService.createNotification('', message.value, NotificationType.ERROR);
        });
    }


    /**
     * Checking Required validation for Add Signature
     */
    validateSignature(signature, editorElement): boolean {
        let isValid = true;
        if ((!signature) || (editorElement && editorElement.innerText && editorElement.innerText.trim().length === 0)) {
            if (editorElement) {
                editorElement.innerHTML = '';
            }
            this.isRequired = true;
            isValid = false;
        }
        return isValid;
    }

    /**
     * To append the email id attribute element
     */
    addEmailIdAttribute(signature): string {
        let updatedSignature: any = this.replaceParagraphTag(signature);
        let matchedEmailList = updatedSignature.match(/([a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]+)/gi);
        if (matchedEmailList && matchedEmailList.length > 0) {
            if (updatedSignature.indexOf('<p id="emailId"></p>') > -1) {
                updatedSignature = updatedSignature.replaceAll('<p id="emailId"></p>', '');
            }
            if (updatedSignature.indexOf('href="mailto:') > -1) {
                updatedSignature = updatedSignature.substring(0, updatedSignature.indexOf('href="mailto:') - 1) + " id='emailId'" + updatedSignature.substr(updatedSignature.indexOf('href="mailto:') - 1);
            } else {
                let emailIndex = updatedSignature.indexOf(matchedEmailList[0]);
                for (let i = emailIndex; i > 0; i--) {
                    if (updatedSignature[i] === '>') {
                        updatedSignature = updatedSignature.substring(0, i) + " id='emailId'" + updatedSignature.substr(i);
                        break;
                    }
                }
            }
        } else if (!(updatedSignature.indexOf('emailId') > -1)) {
            updatedSignature = '<p></p>' + updatedSignature + '<p id="emailId"></p>';
        }
        return updatedSignature;
    }

    /**
     * To Listen the Content Editor when paste the content
     */
    onChangeContentEditor(id: string): void {
        const element = document.getElementById(id);
        if (element) {
            element.addEventListener('paste', (event) => {
                let pastedTypes = event && event.clipboardData && event.clipboardData.types
                    && event.clipboardData.types.length > 0 ? event.clipboardData.types : null;
                if (pastedTypes && pastedTypes.includes('Files')) {
                    event.preventDefault();
                }
            });
        }
    }

    /**
     * To Replace the tag from <div> to <p> for signature
     */
    replaceParagraphTag(signature): string {
        let updatedSignature = signature;
        let index = signature.indexOf('<div>');
        if (index > -1) {
            if (index !== 0) {
                updatedSignature = '<p>' + updatedSignature.substr(0, updatedSignature.indexOf('<div>')) + '</p>' + updatedSignature.substr(updatedSignature.indexOf('<div>'));
            }
            updatedSignature = updatedSignature.replaceAll('<div>', '<p>');
            updatedSignature = updatedSignature.replaceAll('</div>', '</p>');
        }
        index = signature.indexOf('<br>');
        if (index > -1) {
            updatedSignature = updatedSignature.replaceAll('<br>', '');
        }
        return updatedSignature;
    }

    /**
     * Restrict Bold, Italic, Underline
     */
    disableTextStyles(event) {
        let ret = true;
        if (event.ctrlKey) {
            switch (event.keyCode) {
                case 66: //ctrl+B or ctrl+b
                case 98: ret = false;
                    break;
                case 73: //ctrl+I or ctrl+i
                case 105: ret = false;
                    break;
                case 85: //ctrl+U or ctrl+u
                case 117: ret = false;
                    break;
            }
        }
        return ret;
    } // This will work fine for ctrl+c and ctrl+v.

}


// WEBPACK FOOTER //
// ./src/app/customerservice/components/department/email-signature.component.ts